import { render } from "./TestimonialsComponent.vue?vue&type=template&id=2ef96022"
import script from "./TestimonialsComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__